import * as net from 'util/Net';

import {DataPolicy, PolicySpec} from './PolicyConstants';

export interface DataPoliciesResponse {
  dataPolicies: Array<DataPolicy>;
  specByDataPolicyId: {[dataPolicyId: string]: PolicySpec};
}

export function getDataPolicies(): Promise<DataPoliciesResponse> {
  return net.getJSONPromise('/1/api/data-policies');
}

export interface CreateDataPolicyResponse {
  dataPolicy: DataPolicy;
}

export function cloneDataPolicy(dataPolicyId: string, name: string): Promise<CreateDataPolicyResponse> {
  return net.postJSONPromise({
    url: `/1/api/data-policies:clone`,
    data: {dataPolicyId, name},
  });
}

export interface DataPolicyUpdate {
  id: string;
  spec: PolicySpec;
}

export interface UpdateDataPolicyResponse {
  dataPolicy: DataPolicy;
  spec: PolicySpec;
}

export function updateDataPolicy(dataPolicyId: string, spec: PolicySpec): Promise<UpdateDataPolicyResponse> {
  return net.patchJSONPromise({
    url: `/1/api/data-policies/${dataPolicyId}`,
    data: {spec},
  });
}

export function deleteDataPolicy(dataPolicyId: string): Promise<{}> {
  return net.deletePromise({
    url: `/1/api/data-policies/${dataPolicyId}`,
  });
}

export function updateDataPolicies(dataPolicies: Array<DataPolicyUpdate>): Promise<DataPoliciesResponse> {
  return net.patchJSONPromise({
    url: '/1/api/data-policies',
    data: {dataPolicies},
  });
}

export function reorderDataPolicies(dataPolicyIds: Array<string>): Promise<DataPoliciesResponse> {
  return net.postJSONPromise({
    url: '/1/api/data-policies:reorder',
    data: {dataPolicyIds},
  });
}

export function getDataPoliciesURL(): string {
  return '/access-policies';
}

export function getDataPolicyURL(dataPolicyId: string): string {
  return `/data-policies/${dataPolicyId}`;
}

export function getSchemaPoliciesURL(): string {
  return '/schema-policies';
}

export function getSchemaPoliciesSectionURL(section: string): string {
  return `/schema-policies/${section}`;
}

export function getSchemaPolicyURL(schemaPolicyId: string): string {
  return `/schema-policies/${schemaPolicyId}`;
}
